/**
 * Global handler for 401 / session expired. Set by app so API layer can trigger logout + redirect
 * without depending on AuthContext or React Router.
 *
 * When a refresh is in progress (e.g. user clicked "Stay logged in"), 401s from other requests
 * (using the old token) are ignored so we don't clear session before the new token is applied.
 */

let handler: ((reason?: string) => void) | undefined;

/** While true, triggerAuthFailure is a no-op so refresh can complete without being overridden by a 401. */
let refreshInProgress = false;

export function setAuthFailureHandler(fn: ((reason?: string) => void) | undefined): void {
  handler = fn;
}

export function getAuthFailureHandler(): ((reason?: string) => void) | undefined {
  return handler;
}

export function setRefreshInProgress(value: boolean): void {
  refreshInProgress = value;
}

export function triggerAuthFailure(reason?: string): void {
  if (refreshInProgress) return;
  handler?.(reason);
}
